import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LanguageCurrencyComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-language-currency-selector',
  template: `
    <!-- <cx-site-context-selector [context]="siteContextType.LANGUAGE" ></cx-site-context-selector>
    <cx-site-context-selector [context]="siteContextType.CURRENCY" ></cx-site-context-selector> -->
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomLanguageCurrencyComponent extends LanguageCurrencyComponent {}
